import { InjectionToken } from '@angular/core';

export const KIG_SETTINGS = new InjectionToken<string>('KIG_SETTINGS');

export interface KigSettings {
  apiUrl: string;
  googleIconUrl: string;
  graphUrl: string;
  appInsightsConnectionString: string;
  environment?: string;
  envName?: string;
}
